import { render, staticRenderFns } from "./ProjectIssues.vue?vue&type=template&id=e4ab96b4&scoped=true&"
import script from "./ProjectIssues.vue?vue&type=script&lang=js&"
export * from "./ProjectIssues.vue?vue&type=script&lang=js&"
import style0 from "./ProjectIssues.vue?vue&type=style&index=0&id=e4ab96b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4ab96b4",
  null
  
)

export default component.exports